// The two window events netti's tours speak through (client only).
//   innernet:tour        start a tour now ({ id }); the shell plays it (a "walk me through it" link)
//   innernet:agent-make  open the connect-an-agent sheet (a tour's "make one" chip); the agents space answers it.
//                        The ask also waits in the tab (PENDING_MAKE) so a space whose chunk is still loading
//                        picks it up on mount instead of missing the event.

export const TOUR_EVENT = 'innernet:tour'
export const AGENT_MAKE_EVENT = 'innernet:agent-make'

export function startTour(id: string): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(TOUR_EVENT, { detail: { id } }))
}

const PENDING_MAKE = 'innernet:agent-make:pending'

export function openAgentMake(): void {
  if (typeof window === 'undefined') return
  try { sessionStorage.setItem(PENDING_MAKE, String(Date.now())) } catch { /* private mode: the event alone */ }
  window.dispatchEvent(new CustomEvent(AGENT_MAKE_EVENT))
}

/** take (and clear) an ask made in the last 20 seconds; true when there was one. */
export function takeAgentMake(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const at = Number(sessionStorage.getItem(PENDING_MAKE) ?? 0)
    sessionStorage.removeItem(PENDING_MAKE)
    return at > 0 && Date.now() - at < 20_000
  } catch { return false }
}
